import { SectionHeading } from "~/components/DetailsPage/components";
import { Box, Grid } from "@mui/material";
import {
  AdjustedAggregateScoreType,
  AggregateScoresEdges,
} from "~/components/FirewatchPage";
import { Space } from "~/lib/types";
import { FirewatchList } from "~/components/FirewatchList";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";

type ContainedFindingsSectionProps = {
  space: Space;
  scope: SpaceOrWorkspaceScope;
  pageType: AdjustedAggregateScoreType;
  findings: NonNullable<AggregateScoresEdges>;
  loading: boolean;
};

export const TicketFindingsSection = ({
  space,
  scope,
  pageType,
  findings,
  loading,
}: ContainedFindingsSectionProps) => {
  return (
    <Grid size={12}>
      <SectionHeading heading="Contained Findings" />
      <Box className="section-content">
        <FirewatchList
          {...{
            space,
            scope,
            pageType,
            data: findings,
            loading,
            disableSorting: true,
            disableTakeAction: true,
          }}
        />
      </Box>
    </Grid>
  );
};
